import backend from '@common/backend';

const BASE = '/modules';

export interface IGetModulesQuery {
	program_id: number;
	search?: string;
	page?: number;
	limit?: number;
}

export const getModules = (query: IGetModulesQuery) => backend.get(BASE, { params: query });

export const getModule = async (id: number) => backend.get(`${BASE}/${id}`);

export const deleteModule = async (id: number) => backend.delete(`${BASE}/${id}`);

export const updateModule = (id: number, data: any) => backend.put(`${BASE}/${id}`, data);

interface ICreateModuleData {
	program_id: number;
	name: string;
}

export const createModule = ({ program_id, name }: ICreateModuleData) => (
	backend.post(BASE, { program_id, name })
);
